<template>
<main id="app" class="foruwizard">
  <section class="simple-page-section foruwizard-section-step">
    <div class="container fox-container" v-bind:class="{ 'fox-container-step-1': step == 1, 'fox-container-step-2': step == 2 }">
      <div class="row">
        <div class="col-12">
          <div class="foruwizard-fox">
            <img src="../public/images/foruwizard/foxes/fox-1.png" class="foruwizard-fox-1" v-if="step == 1"/>
            <img src="../public/images/foruwizard/foxes/fox-2.png" class="foruwizard-fox-2" v-if="step == 2"/>
            <img src="../public/images/foruwizard/foxes/fox-3.png" class="foruwizard-fox-3" v-if="step == 3"/>
            <img src="../public/images/foruwizard/foxes/fox-5.png" class="foruwizard-fox-5" v-if="step == 4"/>
          </div>
          <div class="foruwizard-breadcrumbs clearfix">
            <div class="foruwizard-breadcrumbs-step" v-bind:class="{ active: step == 1 || step == 2 || step == 3 || step == 4 }" @click="goNextStep(1)"><div class="foruwizard-breadcrumbs-step-icon">1</div></div>
            <div class="foruwizard-breadcrumbs-step" v-bind:class="{ active: step == 2 || step == 3 || step == 4}" @click="goNextStep(2)"><div class="foruwizard-breadcrumbs-step-icon">2</div></div>
            <div class="foruwizard-breadcrumbs-step" v-bind:class="{ active: step == 3 || step == 4}" @click="goNextStep(3)"><div class="foruwizard-breadcrumbs-step-icon">3</div></div>
            <div class="foruwizard-breadcrumbs-step foruwizard-breadcrumbs-step-finish" v-bind:class="{ active: step == 4 }" @click="goNextStep(4)"><div class="foruwizard-breadcrumbs-step-finish-text">Готово</div></div>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-12">
            <!--{{companyobj}}-->
            <step1 v-bind:myNextStep="goNextStep" v-if="step == 1" v-model="companyname" @updatecompany="updateCompanyObject" :propObj="companyobj"></step1>
            <step2 v-bind:myNextStep="goNextStep" v-if="step == 2" @updatecompany="updateCompanyObject" :propObj="companyobj"></step2>
            <step3 v-bind:myNextStep="goNextStep" v-if="step == 3" @updatecompany="updateCompanyObject" :propObj="companyobj"></step3>
            <step4 v-bind:myNextStep="goNextStep" v-if="step == 4" @updatecompany="updateCompanyObject" :propObj="companyobj"></step4>
        </div>
      </div>
    </div>
  </section>
  <div class="authmodal" :class="{active: authmodal}">
    <div class="authmodal-window">
      <div class="authmodal-window-close" @click="authmodal=false"></div>
      <div class="authmodal-window-content">
        <div class="authmodal-window-logo">
          <img src="/images/logo_4u.png" />
        </div>
        <div class="authmodal-window-social">
          <div class="authmodal-window-social-header">Войти с помощью</div>
          <div class="authmodal-window-social-items">
            <a class="nav-link-wm" href="javascript:void(0)" @click="getLoginRedirectUrl('webmoney')" title="Авторизоваться через WebMoney"></a>
            <a class="nav-link-fb" href="javascript:void(0)" @click="getLoginRedirectUrl('facebook')" title="Авторизоваться через Facebook"></a>
            <a class="nav-link-vk" href="javascript:void(0)" @click="getLoginRedirectUrl('vkontakte')" title="Авторизоваться через Vkontakte"></a>
            <a class="nav-link-insta" href="javascript:void(0)" @click="getLoginRedirectUrl('instagram')" title="Авторизоваться через Instagram"></a>
          </div>
        </div>


        <div class="form-group" style="text-align: left;">
          <label style="margin-bottom:20px;" for="userEmail">Ваш email</label>
          <input type="email" v-model="useremail" v-on:keyup.enter="signUp(useremail,userpassword)" @blur="checkemail(useremail, 'remind')" class="form-control" placeholder="Ваш email">

          <!--<input type="email" v-model="useremail" v-on:keyup.enter="signUp(useremail,userpassword)" v-on:dowm="checkemail(useremail, 'remind')" v-on:keyup="checkemail(useremail, 'remind')" class="form-control" placeholder="Ваш email">-->
          <div class="input-error" v-show="useremailerror" style="margin-top:15px;">
            {{useremailerror}}
          </div>
        </div>
        <div class="form-group">
          <label tyle="margin-bottom:20px;" for="userPassword">Ваш пароль</label>
          <input type="password" v-on:keyup.enter="signUp(useremail,userpassword)" v-model="userpassword" class="form-control" placeholder="Ваш пароль">
        </div>
        <div class="form-group text-center">
          <a href="javascript:void(0)" @click="signUp(useremail,userpassword)" :disabled="useremailerror" class="btn btn-circle-salmon btn-circle-salmon-big">Войти</a>
        </div>
        <div class="authmodal-window-links">
          <a href="javascript:void(0)" @click="showRemPassModal">Забыли пароль?</a>
          <a href="https://fo.ru/userregister">Зарегистрироваться</a>
        </div>
        <div class="lds notloadedcontent" v-show="showauthloader">
          <div class="lds-default">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="authmodal" :class="{active: remindpassmodal}">
    <div class="authmodal-window remindpass-window">
      <div class="authmodal-window-close" @click="remindpassmodal=false"></div>
      <div class="authmodal-window-content">
        <div class="authmodal-window-logo">
          <img src="/images/logo_4u.png" />
        </div>
        <div class="remindpass-window-header">Укажите Ваш email</div>
        <div class="form-group email-area">
          <input type="email" v-model="useremail" v-on:keyup.enter="remindPass(useremail)" v-on:keyup="checkemail(useremail, 'remind')" v-on:keydown="checkemail(useremail, 'remind')" class="form-control" placeholder="Ваш email">
          <div class="input-error" v-show="useremailerror">
            {{useremailerror}}
          </div>
        </div>
        <div class="form-group text-center">
          <a href="javascript:void(0)" @click="remindPass(useremail)" :disabled="reminderror" class="btn btn-circle-salmon btn-circle-salmon-big">Восстановить</a>
        </div>
        <div class="authmodal-window-links">
          <a href="https://fo.ru/userregister">Зарегистрироваться</a>
        </div>
      </div>
    </div>
  </div>
  <div class="errorwindow" :class="{active: errorwindow}">
    <div class="errorwindow-header">
      Ошибка
    </div>
    <div class="errorwindow-text">
      {{errortext}}
    </div>
  </div>
  <div class="successwindow" :class="{active: successwindow}">
    <div class="errorwindow-header">
      Успешно
    </div>
    <div class="errorwindow-text">
      {{successtext}}
    </div>
  </div>
</main>
</template>
<script>
import axios from 'axios';

import step1 from './components/step1.vue'
import step2 from './components/step2.vue'
import step3 from './components/step3.vue'
import step4 from './components/step4.vue'
import socialsharer from './components/social-sharer.vue'

// Vue.use(VueLazyload)

window.mobileAndTabletcheck = function() {
  var check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};

function getQueryParams(qs) {
    qs = qs.split('+').join(' ');

    var params = {},
        tokens,
        re = /[?&]?([^=]+)=([^&]*)/g;

    while (tokens = re.exec(qs)) {
        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
    }

    return params;
}

if(window.location.host.indexOf("localhost") > -1){
  axios.defaults.baseURL = 'http://localhost:3000';
  var homeURL = 'http://localhost:3000/home';
  var loginURL = 'http://localhost:3000/login';
}else{
  axios.defaults.baseURL = 'https://editor.fo.ru';
  var homeURL = 'https://editor.fo.ru/home';
  var loginURL = 'https://editor.fo.ru/login';
}
axios.defaults.withCredentials = true;
var authUrl = axios.defaults.baseURL + '/users/sign_in.json';

var appData = {
  whiteheader: false,
  step: 1,
  mobilenavactive: false,
  authmodal: false,
  authorized: false,
  useremail: undefined,
  userpassword: undefined,
  currentuser: false,
  refid: null,
  //userregemail: 'afweb21@gmail.com',
  showusermenu: false,
  playVideo: false,
  bannerImg: 'mainpagebundle/images/banner-1-compressor.jpg',
  laptop: 'mainpagebundle/images/laptop-min2.png',
  iphone: 'mainpagebundle/images/iphone-compressor.png',
  adv1: 'mainpagebundle/images/ic-1-comp.png',
  adv2: 'mainpagebundle/images/ic-2-comp.png',
  adv3: 'mainpagebundle/images/ic-3-comp.png',
  anim: 'mainpagebundle/images/clone_animation_small.gif',
  imag: 'mainpagebundle/images/im-1-min.png',
  fbicon: 'mainpagebundle/images/fbw.svg',
  vkicon: 'mainpagebundle/images/vkw.svg',
  odicon: 'mainpagebundle/images/odnoklassniki-logo.svg',
  wmicon: 'mainpagebundle/images/wmw.svg',
  twicon: 'mainpagebundle/images/twitter-logo-button.svg',
  useremailerror: false,
  useremailalert: false,
  reminderror: true,
  registrok: false,
  errorwindow: false,
  errortext: false,
  successwindow: false,
  successtext: false,
  showloader: false,
  showauthloader: false,
  isRed: false,
  isNotEmpty: false,
  selecttemplateUrl: 'https://editor.fo.ru/selecttemplate',
  homeUrl: homeURL,
  loginUrl: loginURL,
  remindpassmodal: false,
  logoutUrl: axios.defaults.baseURL + '/users/sign_out.json',
  regUrl: axios.defaults.baseURL + '/users.json',
  remindUrl: axios.defaults.baseURL + '/users/password.json',
  checkUserUrl: axios.defaults.baseURL + '/auth/checkuser',
  companyname: "",
  companyaddr: "",
  companyphone: "",
  companyemail: "",
  companyworkhours: "",
  companyobj: {
    data: {
      address: "",
      name: "",
      phone: "",
      email: "",
      category: "",
      facebook: "",
      instagram: "",
      vkontakte: "",
      template_id: ""
    }
  },
  addr: {
    text: "hello",
    lng: "lng",
    lat: "lat"
  }
};
if(mobileAndTabletcheck()){
    appData["selecttemplateUrl"] = "https://editor.fo.ru/selecttemplate"
}else{
    appData["selecttemplateUrl"] = "https://editor.fo.ru/selecttemplate"
}

const alerts = [
  { color: 'negative', message: 'Укажите название компании', icon: 'warning' },
  { color: 'negative', message: 'Укажите адрес компании', icon: 'warning' },
  { color: 'negative', message: 'Укажите номер телефона', icon: 'warning' },
  { color: 'negative', message: 'Укажите email', icon: 'warning' }
]

export default {
  name: 'app',
  components: {
    step1,
    step2,
    step3,
    step4,
    socialsharer
  },
  data: function(){
    return appData;
  },
  directives:{
    scroll:{

    inserted: function(el, binding) {
      let f = function(evt) {
        if (binding.value(evt, el)) {
          // window.removeEventListener('scroll', f)
        }
      }
      window.addEventListener('scroll', f)
      }
    }

  },


  mounted() {
    this.checkAuth()
    console.log("***************")
    console.log(this);
    var prs = getQueryParams(document.location.search);
    this.refid = prs["referer"];
  },


  methods: {
    updateCategoryBlock: function(data){
      console.log(data);
      this.addr = data;
    },
    updateAddrBlock: function(data){
      console.log(data);
      this.addr = data;
    },
    updateCompanyObject: function(data){
      console.log("&&&&&&&&&&&&&&&&&&&")
      console.log(data);
      console.log(this.companyobj);


//      name: this.propObj.data.name,
//              address: this.propObj.data.address,
//              phone: this.propObj.data.phone,
//              category: this.propObj.data.category,
//              description: this.propObj.data.description,
//              facebook: this.propObj.data.facebook,
//              instagram: this.propObj.data.instagram,
//              vkontakte: this.propObj.data.vkontakte,
//              template_id: this.propObj.data.template_id

      this.companyobj.data.name = data.name;
      this.companyobj.data.phone = data.phone;
      this.companyobj.data.address = data.address;
      this.companyobj.data.category = data.category;
      this.companyobj.data.description = data.description;
      this.companyobj.data.facebook = data.facebook;
      this.companyobj.data.instagram = data.instagram;
      this.companyobj.data.vkontakte = data.vkontakte;
      this.companyobj.data.template_id = data.template_id;
      if(data.email && data.email != ''){
        this.companyobj.data.email = data.email
      }
//
//      if(email == ""){
//        this.companyobj = data;
//      }else{
//        console.log(email);
//
//      }
      // this.companyobj = data;


//      this.companyobj = {data: data};



      // console.log(this.companyobj);
    },

    handleScroll: function(evt, el) {
      if (window.scrollY > 50) {
        this.whiteheader = true;
      }else{
        this.whiteheader = false;
      }
      return window.scrollY > 100
    },
    showNotif (alert) {
      this.$q.notify({
        message: alert.message,
        color: alert.color,
        position: 'top-right',
        icon: alert.icon
      })
    },
    goNextStep(step){
      if(step == 2){
        if(!this.companyobj.data.name || this.companyobj.data.name ==''){
          this.showNotif(alerts[0]);
          return;
        }
      }
      if(step == 3){
        console.warn(this.companyobj.data)
        if(!this.companyobj.data.name || this.companyobj.data.name ==''){
          this.showNotif(alerts[0]);
          return;
        }
        if(!this.companyobj.data.address || this.companyobj.data.address == ''){
          this.showNotif(alerts[1]);
          return;
        }
//        if(!this.companyobj.data.phone || this.companyobj.data.phone == ''){
//          this.showNotif(alerts[2]);
//          return;
//        }
        if(!this.companyobj.data.email || this.companyobj.data.email == ''){
          this.showNotif(alerts[3]);
          return;
        }
      }
      if(step == 4){
        if(!this.companyobj.data.name || this.companyobj.data.name ==''){
          this.showNotif(alerts[0]);
          return;
        }
        if(!this.companyobj.data.address || this.companyobj.data.address == ''){
          this.showNotif(alerts[1]);
          return;
        }

        if(!this.companyobj.data.email || this.companyobj.data.email == ''){
          this.showNotif(alerts[3]);
          return;
        }
      }
      this.step = step;
    },


    setAuth: function(response){
      console.warn(response);
      console.warn(this);
      this.authorized = true;
      this.currentuser = response.data;
      console.log("companyobjcompanyobjcompanyobjcompanyobj222222");
      console.log(this.currentuser);
      if(this.companyobj){
        if(this.companyobj.data){
//          this.companyobj.data.email = "cdscdscds@cdscsdcdsc";
          this.companyobj.data.email = this.currentuser.validemail || this.currentuser.email;
        }
      }
      console.log("companyobjcompanyobjcompanyobjcompanyobj", this.companyobj);
      this.authmodal = false;
      if(!response.data.image){
	      if(response.data.provider == "webmoney"){
          this.currentuser.image = 'https://events.webmoney.ru/open/avatar.aspx?t=Url&s=Normal&w='+response.data.wmid
        }else{
          this.currentuser.image = 'https://gravatar.com/avatar/d99699d422699748c0c542dfa6e55c47?d=https://fo.ru/img/userimage.png';
        }
    	//this.currentuser.image = 'https://gravatar.com/avatar/d99699d422699748c0c542dfa6e55c47?d=https://fo.ru/img/userimage.png';
      }
      if(window.location.pathname.indexOf('login') > -1 || window.location.pathname.indexOf('userregister') > -1){
        window.location = this.homeUrl;
      }
    },
    openModal: function(modal){
      console.log(this.authorized);
      if(this.authorized){
	      window.location.href = 'https://editor.fo.ru/selecttemplate'
      }else{
        this.useremail = undefined;
        this.useremailerror = false;
        this[modal] = true;
      }
    },
    checkAuth: function(callback){
      let self = this;
      axios
        .post(authUrl, {})
        .then(function (response) {
          console.log("checkAuth");
          console.log(response);
          self.setAuth(response);
          if(callback){
            callback();
          }
          // $(".notloadedcontent").removeClass("notloadedcontent");
        })
        .catch(function (error) {
          // $(".notloadedcontent").removeClass("notloadedcontent");
        });
    },
    getLoginRedirectUrl: function(provider){
      console.warn(provider)
      let url = 'https://editor.fo.ru/auth/getredirecturl/'+provider+"?referer="+this.refid
      let mywindow = window.open("https://yep.com","_blank", 'width=700,height=600')
      let self = this;
      axios
        .get(url)
        .then(function (response) {
          console.warn(response);
          mywindow.location = response.data.redirect_url;
          var timer = setInterval(function() {
              if(mywindow.closed) {
                clearInterval(timer);
                self.checkAuth(function(){
                  if(self.authorized){
                    window.location = self.homeUrl;
                  }
                });
              }
          }, 1000);
        })
    },
    signUp: function(email, password){
      self = this;
      if(!email || !password){
        this.errortext = "Заполните все поля";
        this.errorwindow = true;
        setTimeout(function(){
          this.errorwindow = false;
          self.errorwindow = false;
        },2000);
        return false
      }
      this.showauthloader = true;

      axios
        .post(authUrl, {user: {email: email, password: password}})
        .then(function (response) {
          self.setAuth(response);
          self.showauthloader = false;
          window.location = self.homeUrl;
        })
        .catch(function (error) {
          self.showauthloader = false;
          self.errortext = error.response.data.error;
          self.errorwindow = true;
          setTimeout(function(){
            self.errorwindow = false;
          },2000);
        });
    },
    showUserMenu: function(){
      this.showusermenu = !this.showusermenu;
    },
    Logout: function(){
      self = this;
      axios
        .delete(this.logoutUrl, {})
        .then(function (response) {
          self.authorized = false;
          self.currentuser = false;
          self.showusermenu = false;
        })
      .catch(error => console.log(error));
    },
    createwebsite: function(evt){
      if(!this.authorized){
        evt.preventDefault();
        this.authmodal = true;
      }
    },
    validEmail: function (email) {
      var re = /^\S+@\S+$/;
      return re.test(email);
    },
    checkemail: function (email, action){
      console.log(email);
      console.log(this.validEmail(email));
      if(email && email.length > 3){
        if(!this.validEmail(email)){
          this.useremailerror = "Введен некорректный Email";
          this.useremailalert = false;
        }else{
          let self = this;
          axios
            .get(this.checkUserUrl + "?email=" + email, '')
            .then(function (response) {
              if (action) {
                if (action == 'registr') {
                  self.useremailerror = false;
                  if (response.data.exists) {
                    self.useremailalert = "Данный email уже используется";
                  }else{
                    self.useremailalert = false;
                  }
                }
                if (action == 'remind') {
                  if (response.data.exists) {
                    self.useremailerror = false;
                    self.reminderror = false;
                  } else {
                    self.reminderror = true;
                    self.useremailerror = "Данный адрес не зарегистрирован";
                  }
                }
              }
            });
        }
      }else{
        this.useremailerror = false;
      }
    },
    userRegister: function(email){
      if(!email){
        this.errortext = "Укажите Email";
        this.errorwindow = true;
        setTimeout(function(){this.errorwindow = false;},2000);
        return false
      }else{
        if(this.validEmail(email)){
          self = this;
          axios
            .get(this.checkUserUrl + "?email=" + email, '')
            .then(function (response) {
              if(response.data.exists){
                self.authmodal = true;
              }else{
                self.showloader = true;
                self.currentuser = true;
                self.registrok = true;
                axios
                  .post(this.regUrl, {user: {email: email, referer: this.refid}, email: email, referer: this.refid})
                  .then(function (response) {
                    self.setAuth(response);
                    self.showloader = false;
                    self.registrok = false;
                    //window.location = this.selecttemplateUrl;
                  })
                  .catch(function (error) {
                    self.currentuser = false;
                    self.showloader = false;
                  });
              }
            });
        }else{
          this.errortext = "Введен некорректный Email";
          this.errorwindow = true;
          setTimeout(function(){this.errorwindow = false;},2000);
          return false
        }
      }
    },
    showRemPassModal: function (){
      this.authmodal = false;
      this.useremail = undefined;
      this.useremailerror = false;
      this.remindpassmodal = true;
    },
    remindPass: function (email){
      self = this;
      if(!email){
        self.errortext = "Укажите Email";
        self.errorwindow = true;
        setTimeout(function(){self.errorwindow = false;},2000);
        return false
      }
      axios
        .post(this.remindUrl, {user: {email: email}})
        .then(function (response) {
          self.remindpassmodal = false;
          self.successwindow = true;
          self.successtext = "Инструкция отправлена на указанную почту"
          setTimeout(function(){self.successwindow = false;},2000);
        })
        .catch(function (error) {
          self.errortext = 'Такого адреса не существует';
          self.errorwindow = true;
          setTimeout(function(){self.errorwindow = false;},2000);
        });
    }
  }
}
</script>

<style lang="scss">

html,
body{
  height: 100%;
}

body{
  position: relative;
  background-color: #ffffff;
  &.foruwizard-body{
    font-family: 'MuseoSansCyrl', sans-serif;
    .q-item{
      margin-left: 0;
      margin-right: 0;
    }
    .q-field{
      margin-left: 0;
      margin-right: 0;
    }
    .q-field--outlined.q-field--focused .q-field__control:after{
      border-width: 1px;
    }
    .material-icons.q-icon.text-negative{
      position: relative;
      z-index: 1;
      background-color: #fff;
    }
    .q-field__append.q-field__marginal.row.no-wrap.items-center + .q-anchor--skip{
      display: none;
    }
    .q-textarea .q-field__native{
      resize: none;
    }
    input.otherclass{
      visibility: hidden;
      opacity: 0;
      animation: contentopacity 1s ease;
    }
    #foruwizard-select span:not(:empty) + .q-select__input--padding{
      visibility: hidden;
      opacity: 0;
      cursor: default;
    }
    .q-field--outlined .q-field__control{
      background-color: #fff;
    }
  }
}

header.white:after{
  display: none;
}

#app{
  min-width: 320px;
  font-family: 'MuseoSansCyrl', sans-serif;
  height: 100%;
  text-align: center;
  color: #2c3e50;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.foruwizard{
  header{
    height: 64px;
  }
}

.foruwizard-breadcrumbs{
  margin-bottom: 16px;
  @media all and (min-width: 768px){
    margin-bottom: 24px;
  }
}


.foruwizard-breadcrumbs-step{
  position: relative;
  float: left;
  transition: padding ease 0.5s;
}

.foruwizard-breadcrumbs-step-icon{
  font-size: 14px;
  font-weight: 300;
  line-height: 22px;
  position: relative;
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  cursor: default;
  color: rgba(199, 199, 199, 0.9);
  border: 1px solid rgba(199, 199, 199, 0.9);
  border-radius: 24px;
  background-color: #ffffff;
  @media all and (min-width: 768px){
    font-size: 18px;
    line-height: 46px;
    width: 48px;
    height: 48px;
    border-radius: 48px;
  }
}

.foruwizard-breadcrumbs-step-finish{
  .foruwizard-breadcrumbs-step-finish-text{
    font-size: 14px;
    font-weight: 300;
    line-height: 22px;
    position: relative;
    width: 80px;
    text-align: center;
    cursor: default;
    color: rgba(199, 199, 199, 0.9);
    border: 1px solid rgba(199, 199, 199, 0.9);
    border-radius: 24px;
    background-color: #ffffff;
    @media all and (min-width: 768px){
      font-size: 18px;
      line-height: 46px;
      width: 120px;
    }
  }
  &.active .foruwizard-breadcrumbs-step-finish-text{
    color: #e88a74;
    border-color: #e88a74;
  }
}

.foruwizard-breadcrumbs-step.active .foruwizard-breadcrumbs-step-icon{
  color: #e88a74;
  border-color: #e88a74;
}

.foruwizard-breadcrumbs-step.active + .foruwizard-breadcrumbs-step:not(.active){
  padding-left: 80px;
  @media all and (min-width: 768px){
    padding-left: 184px;
  }
}


.foruwizard-breadcrumbs-step + .foruwizard-breadcrumbs-step:before{
  position: absolute;
  top: 12px;
  right: 40px;
  left: 0;
  display: block;
  content: '';
  transition: all ease 0.5s;
  border-top: 1px dotted rgba(199, 199, 199, 0.9);
  @media all and (min-width: 768px){
    top: 24px;
    right: 64px;
  }
}

.foruwizard-breadcrumbs-step.active + .foruwizard-breadcrumbs-step:before{
  right: 40px;
  @media all and (min-width: 768px){
    right: 64px;
  }
}

.foruwizard-breadcrumbs-step.active + .foruwizard-breadcrumbs-step-finish:before{
  right: 88px;
  @media all and (min-width: 768px){
    right: 128px;
  }
}

.foruwizard-section-step{
  position: relative;
  min-height: 100%;
  margin-bottom: 0;
  padding-top: 125px;
  padding-bottom: 80px;
  overflow-x: hidden;
  background: transparent url(../public/images/foruwizard/bg-shadow.svg) left bottom 120px no-repeat;
  @media all and (min-width: 768px){
    padding-top: 128px;
  }
}

.foruwizard-section-step:after{
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;
  height: 80px;
  content: '';
  background: transparent url(../public/images/foruwizard/bg-town.png) left bottom repeat-x;
}

.foruwizard-fox{
  margin-bottom: 24px;
  height: 120px;
  @media all and (min-width: 768px){
    height: auto;
    margin-bottom: 0;
    position: absolute;
    right: 0;
    top: -88px;
  }
  @media all and (min-width: 992px){
    top: 0;
  }
  img{
    max-height: 120px;
    display: block;
    margin: auto;
    @media all and (min-width: 992px){
      float: right;
      max-height: 180px;
    }
  }
}


.foruwizard-fox-1,
.foruwizard-fox-2,
.foruwizard-fox-3,
.foruwizard-fox-5{
  animation: foxruntop .5s ease;
  @media all and (min-width: 768px){
    animation: foxrun 1s ease;
  }
}


.foruwizard-step-content{
  animation: contentopacity 1s ease;
}

.foruwizard-step-header{
  animation: leftright .8s ease;
}

@keyframes foxruntop {
  from{
    position: relative;
    top: -200px;
    opacity: 0;
  }
  to{
    position: relative;
    top: 0;
    opacity: 1;
  }
}

@keyframes foxrun {
  from{
    margin-right: -200px;
    opacity: 0;
  }
  to{
    margin-right: 0;
    opacity: 1;
  }
}

@keyframes contentopacity {
  from{
    opacity: 0;
  }
  to{
    opacity: 1;
  }
}

@keyframes leftright {
  from{
    opacity: 0;
    margin-left: -500px;
  }
  to{
    opacity: 1;
    margin-left: 0;
  }
}

.registr-box{
  background-color: transparent;
}
</style>
